import { useSelector } from 'react-redux';

export function useOnce(collection) {
    return useSelector((state) => state.once[collection]) ?? [];
}
